export default {
        'लाल' : '#de3532',
        'काली' : '#000000',
        'हरा' : '#138808',
        'लाल रंग' : 'red',
        'ऑरेंज ' : 'orange',
        'black' : '#000000',
        'green' : '#138808',
        'गहरा नीला' : 'blue',
        'बैंगनी' : 'violet',
        'शाही नीला': 'darkblue',
        'maroon': 'red',
        'navy blue' : 'darkblue',
        'purple' : 'purple',
        'royal blue' : 'royalblue'
    }
    